import { Injectable } from "@angular/core";

import { Moment } from "moment";
import moment from "moment-timezone";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { CountryTimeZones } from "../models/country-timezones.model";
import { StructureDTO } from "../models/structure-dto";
import { ConfigurationService } from "./configuration.service";
import { DataService } from "./data.service";

@Injectable()
export class StructureService {
  private ePermitsUrl = "";

  constructor(
    private service: DataService,
    private configurationService: ConfigurationService,
  ) {
    if (this.configurationService.isReady) {
      this.ePermitsUrl = this.configurationService.serverSettings.ePermitsUrl;
    } else {
      this.configurationService.settingsLoaded$.subscribe(
        (x) => (this.ePermitsUrl = x?.ePermitsUrl),
      );
    }
  }

  get(rootId: number): Observable<StructureDTO> {
    const url = `${this.ePermitsUrl}/api/v1/structure/tree?rootId=${rootId}`;

    return this.service.get(url).pipe(
      map((response: any) => {
        return response;
      }),
    );
  }
}
